import API from "@/models/API";
import router from "@/routes"

let storesType = () => ((router?.history.current.path||'').split('/')||[])[2] == 'storePanel' ? 'stores':'companies'
    

export default class Attribute {

    constructor(item = {}) {
        this.attribute_id = item.attribute_id || null;
        this.name = item.name || {
            el: "",
            en: "",
            it: ""
        };
        this.description = item.description || {
            el: "",
            en: "",
            it: ""
        };
    }

    
    static getAttributes = (q='') =>
        API.get(
            `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/attributes${q}`
        );
    
        static createAttribute = (body) =>
        API.post(
            `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/attributes`, body
        );
    
        static updateAttribute = (id,body) =>
        API.put(
            `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/attributes/${id}`, body
        );
    
        static deleteAttribute = (id) =>
        API.delete(
            `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/attributes/${id}`
        );

}
